//FOR ORBE
document.addEventListener("DOMContentLoaded", () => {
  const helperTexts = document.querySelectorAll(".orbe--opened .md-modal__bodyContent__text");
  if (!helperTexts.length) return;

  helperTexts.forEach(el => {
    el.addEventListener("click", () => {
      if (typeof orbitoMK !== "undefined" && typeof orbitoMK.openModal === "function") {
        orbitoMK.openModal("md-app-embed__footer-popup");
      } else {
        console.warn("orbitoMK or orbitoMK.openModal is not available.");
      }
    });
  });
});

// TO DETECT WHEN FILTER BAR IS STICKY AND APPLY BORDER STYLES
document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelector('.collection-filters');
  const header  = document.querySelector('.h-header');
  if (!filters || !header) return;

  let lastIsStuck = null;
  let ticking = false;

  function computeIsStuck() {
    // Always read fresh height; it can change with state/transparency
    const headerHeight = header.offsetHeight || 0;
    const filtersTop   = filters.getBoundingClientRect().top;
    return filtersTop <= headerHeight;
  }

  function update() {
    ticking = false;
    const isStuck = computeIsStuck();
    if (isStuck !== lastIsStuck) {
      filters.classList.toggle('filters-stuck', isStuck);
      header.classList.toggle('hide-border', isStuck);
      lastIsStuck = isStuck;
    }
  }

  function onScrollOrResize() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  window.addEventListener('orientationchange', onScrollOrResize);
  window.addEventListener('load', onScrollOrResize);

  // Initial run (mid-page loads)
  update();
});


//MOBILE COLLECTION GALLERY SCROLLBAR
// Minimal mobile gallery ticks: bind once, auto-bind on newly added cards.
(() => {
  const SELECTOR = '.product-card .card-image .scroll-gallery';
  const GRID = document.querySelector('#collection-card-listing') || document;

  document.addEventListener('DOMContentLoaded', initAll);
  // If your pagination code replaces HTML, this observer will catch it.
  new MutationObserver(initAll).observe(GRID, { childList: true, subtree: true });

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(bindGallery);
  }

  function bindGallery(gallery) {
    if (gallery.dataset.bound) return;
    gallery.dataset.bound = '1';

    // slides = only direct children
    let slides = gallery.querySelectorAll(':scope > .gallery-item');
    if (!slides.length) return;

    const pagination =
      gallery.nextElementSibling?.classList?.contains('gallery-pagination')
        ? gallery.nextElementSibling
        : gallery.parentElement?.querySelector?.('.gallery-pagination');

    if (!pagination) return;

    // Build ticks once
    if (pagination.children.length !== slides.length) {
      pagination.innerHTML = Array.from(slides, (_, i) =>
        `<span class="item${i === 0 ? ' item-active' : ''}"></span>`
      ).join('');
    }
    const ticks = Array.from(pagination.children);
    const setActive = (i) => ticks.forEach((t, idx) => t.classList.toggle('item-active', idx === i));

    // Cheap center-based active detection
    let raf;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const center = gallery.scrollLeft + gallery.clientWidth / 2;
        let bestIdx = 0, bestDist = Infinity;
        slides.forEach((el, idx) => {
          const elCenter = el.offsetLeft + el.offsetWidth / 2;
          const d = Math.abs(center - elCenter);
          if (d < bestDist) { bestDist = d; bestIdx = idx; }
        });
        setActive(bestIdx);
      });
    };

    gallery.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // set initial tick
  }
})();

//TO OPEN COOKIE PREFERENCES
document.addEventListener('DOMContentLoaded', function() {
  // Watch for clicks on links containing #cookie
  document.querySelectorAll('a[href*="#cookie-preferences"]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      openShopifyCookiePreferences();
    });
  });

  // Also open automatically if URL has #cookie
  if (window.location.hash === '#cookie-preferences') {
    openShopifyCookiePreferences();
  }

  function openShopifyCookiePreferences() {
    const prefs = document.querySelector('#shopify-pc__prefs');
    if (!prefs) {
      console.warn('Shopify cookie preferences not found on this page.');
      return;
    }

    prefs.style.display = 'block';
    prefs.setAttribute('aria-hidden', 'false');

    const dialog = document.querySelector('#shopify-pc__prefs__dialog');
    if (dialog) {
      dialog.setAttribute('aria-modal', 'true');
      dialog.focus();
    }
  }
});
